export default __webpack_public_path__ + "static/media/img2.b9ce407c.png";